// Sass-like functionality for styled-components
const values = {
	fontFamily: {
		regular:
			'"FS Elliot Web Regular", "FS Elliot Web Regular", "Arial", arial, sans-serif',
		bold: '"FS Elliot Web Bold", "FS Elliot Web Bold", "Arial", arial, sans-serif',
		light: '"FS Elliot Pro Light", "FS Elliot Web Regular", Arial, arial, sans-serif',
		heavy: '"FS Elliot Pro Heavy", "FS Elliot Web Bold", Arial, arial, sans-serif',
	},
};
export const mixins = {
	include: {
		fontRegular: () => {
			return `font-family: ${values.fontFamily.regular};
				font-weight: normal;
				font-style: normal;
				`;
		},
		fontBold: () => {
			return `font-family: ${values.fontFamily.bold};
				font-weight: normal;
				font-style: normal;
				`;
		},
		fontLight: () => {
			return `font-family: ${values.fontFamily.light};
			font-weight: normal;
			font-style: normal;
			`;
		},
		fontHeavy: () => {
			return `font-family: ${values.fontFamily.heavy};
			font-weight: bolder;
			font-style: normal;
			`;
		},
	},
};

export const variables = {
	color: {
		white: "#FFF",
		black: "#000",
		gray: "#c7c7c7",
		darkGray: "#333333",
		lightBlue: "#e5f4fb",
		darkBlue: "#024272",
		mediumLightGray: "#e6e6e6",
		mediumDarkBlue: "#00599C",
		gray2: "#616267",
		gray4: "#C5C6C5",
		gray5: "#757575",
		gray6: "#F6F6F8",
		gray7: "#FBFBFB",
		brandPrimary: "#035fa4",
		safetyOrange: "#ff7000",
		darkYellow: "#f1ae13",
		yellow: "#ffc82e",
		fauxGreen: "#00c19f",
		navyBlue: "#0076cf",
		navyBlue2: "#0176cf",
		purple: "#68478d",
		purple2: "#68468d",
		purple3: "#4b4687",
		purple4: "#464e7e",
		carrot: "#ff9231",
		aquaBlue: "#00c4d9",
		admiralBlue: "#0061A0",
		mediumAdmiralBlue: "#004887",
		darkAdmiralBlue: "#002E6D",
		prussianBlue: "#003865",
		darkNavyBlue: "#002855",
		cyan: "#00C4D9",
		cyan2: "#01c4d9",
		darkCyan: "#007FA3",
		pacificBlue: "#0091da",
		skyBlue: "#94D8FA",
		charcoal: "#464646",
		lightGray: "#f1f1f1",
		lightGray2: "#f6f6f6",
		lightGray3: "#efefef",
		lightGray4: "#e8e8e8",
		teelGreen: "#01c19f",
		green: "#007c75",
		lightPurple: "#cc99ff",
	},
};

const sass = {
	mixins,
	variables,
	values,
};

export default sass;
